<div class="package-description">
    <hyperkit-typography variant="h5">DESCRIPTION</hyperkit-typography>
    <hyperkit-markdown color="secondary" [md]="hunt.editor.description()">
    </hyperkit-markdown>
</div>
<div class="package-info">
    <div class="section info-1">
        <div id="created-date">
            <hyperkit-typography variant="label1">Created</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.createdDate() | date: 'MMMM d, y' }}</hyperkit-typography>
        </div>
        <div id="last-updated">
            <hyperkit-typography variant="label1">Last Updated</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.lastUpdatedDate() | date: 'MMMM d, y' }}</hyperkit-typography>            
        </div>
        <div id="severity">
            <hyperkit-typography variant="h5">Severity</hyperkit-typography>
            <hyperkit-badge
            [variant]="hunt.editor.severityVariant()"
            [size]="'base'"
            [indicator]="'none'"
            [icon]="'check'"
            [text]="hunt.editor.severity()">
          </hyperkit-badge>
              
        </div>
        <div id="threat-name">
            <hyperkit-typography variant="label1">Threat Names</hyperkit-typography>
            <ng-container *ngIf="relatedThreatProfiles().length > 0">
                <ng-container *ngFor="let threatProfile of relatedThreatProfiles() let isLast = last">
                  <hyperkit-link 
                  [routerLink]="['/research/threat-profile', threatProfile.profile_id]"  
                  variant="button2" 
                  color="primary" 
                  display="inline"
                  [text]="threatProfile.title + (isLast ? '' : ',\u00A0')">
                </hyperkit-link>
                </ng-container>
          </ng-container>        </div>
    </div>
    <div class="section info-2">
        <div id="threat-categories">
            <hyperkit-typography variant="label1">Threat Categories</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.threatCategories() }}</hyperkit-typography>
        </div>
        <div id="source-countries">
            <hyperkit-typography variant="label1">Source Countries</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.sourceCountries() }}</hyperkit-typography>
        </div>
        <div id="actors">
            <hyperkit-typography variant="label1">Actors</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.actors() }}</hyperkit-typography>

        </div>
        <div id="target-oses">
            <hyperkit-typography variant="label1">Target Osses</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.targetOses() }}</hyperkit-typography>
        </div>
    </div>
    <div class="section info-3">
        <div id="threat-dependencies">
            <hyperkit-typography variant="label1">Dependencies</hyperkit-typography>
            <div id="threat-dependencies-container">
                <div *ngFor="let dependency of hunt.editor.dependencies()">
                    <hyperkit-typography variant="body1" color="secondary">{{ dependency }}</hyperkit-typography>
                  </div>
              
            </div>
        </div>
        <div id="diamond-model">
            <hyperkit-typography variant="label1">Diamond Model</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.diamondModel() }}</hyperkit-typography>
        </div>
        <div id="kill-chains">
            <hyperkit-typography variant="label1">Kill Chains</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.killChains() }}</hyperkit-typography>

        </div>
        <div id="mitre-attack-tactics">
            <hyperkit-typography variant="label1">Mitre Attack Tactics</hyperkit-typography>
            <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.mitreAttackTactics() }}</hyperkit-typography>
        </div>
    </div>
</div>
<div class="package-footer">
    <div class=" top">
        <div id="mitre-attack">
            <div id="mitre-attack-technique">
                <hyperkit-typography variant="label1">Mitre Attack Technique</hyperkit-typography>
                <hyperkit-typography variant="body1" color="secondary">{{ hunt.editor.mitreAttackTechniques() }}</hyperkit-typography>
            </div>
        </div>
        <div id="related-collections">
            <div id="related-collections">
                <hyperkit-typography variant="label1">Related Collections</hyperkit-typography>
                    <ng-container *ngIf="relatedCollections().length > 0">
                          <ng-container *ngFor="let collection of relatedCollections() let isLast = last">
                            <hyperkit-link 
                            (click)="navigateToCollection(collection.UUID)"
                            variant="button2" 
                            color="primary" 
                            display="inline"
                            [text]="collection.title + (isLast ? '' : ',\u00A0')">
                          </hyperkit-link>
                          </ng-container>
                    </ng-container>
            </div>
        </div>
    </div>
    <div class="section bottom">
        <!-- TAGS SECTION -->
    </div>
</div>
